import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchNotifications = createAsyncThunk(
    'notifications/fetch',
    async ({ userId, organizationId }, { rejectWithValue }) => {
        const jwtToken = localStorage.getItem("jwt_token");
        const URL = `${process.env.REACT_APP_API_URL}/badge_notification?user_id=${userId}&organisation_id=${organizationId}`;
        try {
            const response = await axios.get(URL, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Fetch failed');
        }
    }
);

export const markNotificationAsRead = createAsyncThunk(
    'notifications/markAsRead',
    async ({ user_id, organisation_id, title }, { rejectWithValue }) => {
        const jwtToken = localStorage.getItem("jwt_token");
        const URL = `${process.env.REACT_APP_API_URL}/update_badge_notification`;
        const payload = {
            user_id,
            organisation_id,
            title,
            is_read: 1,
        };

        try {
            const response = await axios.post(URL, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return { title };
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Update failed');
        }
    }
);


const notificationSlice = createSlice({
    name: 'notifications',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotifications.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(fetchNotifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(markNotificationAsRead.fulfilled, (state, action) => {
                const { title } = action.payload;
                state.data = state.data.map((notification) =>
                    notification.title === title
                        ? { ...notification, is_read: 1 }
                        : notification
                );
            });
    },
});

export default notificationSlice.reducer;
